// src/locales/si/storePickup.js
export const storePickup = {
  // Page
  pageTitle: "Store Pickup ඇණවුම්",
  pageDescription: "පුද්ගලිකව රැගෙන යන ඇණවුම් යැවීම දක්වා නිරීක්ෂණය කරන්න",
  searchPlaceholder: "ඇණවුම් අංකය, ගනුදෙනුකරුගේ නම හෝ දුරකථන අංකයෙන් සොයන්න...",
  orderDate: "ඇණවුම් දිනය",

  // Columns
  orderNumber: "ඇණවුම් අංකය",
  customerName: "ගනුදෙනුකරු",
  phone: "දුරකථනය",
  deliveryNotes: "බෙදාහැරීමේ සටහන්",
  deliveryNotesPlaceholder: "සටහනක් එක් කරන්න...",
  deliveryNotesSaveFailed: "බෙදාහැරීමේ සටහන් සුරැකීම අසාර්ථක විය",

  // Row actions
  viewOrder: "ඇණවුම බලන්න",
  viewPaymentRecords: "ගෙවීම් වාර්තා බලන්න",
  paymentRecords: "ගෙවීම් වාර්තා",
  dispatch: "යවන්න",
  dispatchBlockedUnverified: "සත්‍යාපනය නොකළ ගෙවීම් වාර්තාවක් ඇති විට යැවීම අවහිර වේ",

  // Dispatch modal
  dispatchOrder: "ඇණවුම යවන්න",
  warehouse: "ගබඩාව",
  selectWarehouse: "ගබඩාවක් තෝරන්න",
  warehouseRequired: "කරුණාකර ගබඩාවක් තෝරන්න",
  dispatchedDate: "යැවූ දිනය",
  backdateNotAllowed: "යැවූ දිනය පසුගාමී කිරීමට ඔබට අවසර නැත",
  dispatchSuccess: "ඇණවුම සාර්ථකව යවන ලදී",
  dispatchFailed: "ඇණවුම යැවීම අසාර්ථක විය",

  // Empty / error states
  noOrdersFound: "Store Pickup ඇණවුම් හමු නොවීය",
  noOrdersFoundDescription: "Store Pickup ගෙවීම් වර්ගය සහිත ඇණවුම් මෙහි දිස්වේ",
  failedToLoad: "Store Pickup ඇණවුම් පූරණය අසාර්ථක විය",

  // Open in POS
  deletePayment: "ගෙවීම මකන්න",
  confirmDeletePayment: "මෙම තහවුරු නොකළ ගෙවීම් වාර්තාව මකන්නද?",
  deletePaymentSuccess: "ගෙවීම් වාර්තාව මකා දමන ලදී",
  deletePaymentFailed: "ගෙවීම් වාර්තාව මැකීම අසාර්ථක විය",
  verifiedLocked: "තහවුරු කළ ගෙවීම් වෙනස් කළ නොහැක",
  openInPos: "POS ටර්මිනලයේ විවෘත කරන්න",
  selectPosShop: "POS ටර්මිනලය තෝරන්න",
  posShop: "POS ටර්මිනලය",
  open: "විවෘත කරන්න",
  noPosShop: "ඔබ කිසිදු POS ටර්මිනල් සාප්පුවකට පවරා නැත",
};
